<template lang="pug">
  div.comment
    icon(v-if="busy" name="refresh" scale="3" spin)
    //- p {{url}}
    div.title
      a(:href="comment.permalink" target="_blank") {{comment.title}}
    div.quote
      blockquote(v-html="decodeHtml(comment.text)")
    div.comment__foot
      div
        span ~&nbsp;
        a(:href="`https://reddit.com/u/${comment.author}`" target="_blank") {{comment.author}}
      div
        ul.sendoff
          li
            a(:href="comment.context" target="_blank") [article]
</template>

<script>
// import * as moment from 'moment'

class RedditFetcher {
  async fetchComment (url) {
    const response = await fetch(url)
    return await response.json()
  }
}

export default {
  props: {
    u: { type: String, required: true }
  },
  data () {
    return {
      busy: true,
      jsonUrl: '',
      comment: null
    }
  },
  methods: {
    decodeHtml (html) {
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      const val = txt.value
      return val
    },
    parseUrl () {
      let jsonUrl = ''
      if (this.u.endsWith('/')) {
        jsonUrl = `${this.u.slice(0, -1)}.json`
      } else {
        jsonUrl = `${this.u}.json`
      }
      console.log(jsonUrl)
      this.jsonUrl = jsonUrl
    },
    async fetchComment () {
      const fetcher = new RedditFetcher()
      const [root, comment] = await fetcher.fetchComment(this.jsonUrl)
      if (comment.data.children[0].kind === 't1') {
        this.comment = {
          author: comment.data.children[0].data.author,
          title: root.data.children[0].data.title,
          text: comment.data.children[0].data.body_html,
          permalink: `https://reddit.com${root.data.children[0].data.permalink}`,
          context: root.data.children[0].data.url
        }
      } else if (root.data.children[0].kind === 't1') {
        console.log('IS ROOT EVER T1??')
        this.comment = {
          author: root.data.children[0].data.author,
          title: comment.data.children[0].data.title,
          text: root.data.children[0].data.body,
          permalink: `https://reddit.com${comment.data.children[0].data.permalink}`,
          context: comment.data.children[0].data.url
        }
      }
      this.busy = false
    }
  },
  created () {
    this.parseUrl()
  },
  mounted () {
    this.fetchComment()
  }
}
</script>

<style lang="stylus">
  ul.sendoff
    margin 0
    li
      font-size 0.6rem
      font-weight bold
      margin 0.4rem 0.2rem
      display inline-block

  .comment
    max-width 100vw
    overflow hidden
    margin 0 0 5rem 0
    &__foot
      margin -0.2rem
      padding 0.2rem
      // background-color #fefefe
      // box-shadow 0 0 4px rgba(0, 0, 0, 0.2)
      // border-radius 0.4rem
      display flex
      flex-direction horizontal
      align-items center
      justify-content space-between
  blockquote
    background #f9f9f9
    border-left 10px solid #ccc
    margin 1.5em 10px
    padding 0.5em 10px
    quotes "\201C""\201D""\2018""\2019"
  blockquote:before
    color #ccc
    content open-quote
    font-size 4em
    line-height 0.1em
    margin-right 0.25em
    vertical-align -0.4em
  blockquote blockquote
    border-left none
    padding 0
    margin 0
    quotes none
</style>



// WEBPACK FOOTER //
// RedditComment.vue?1d290cc8